import type { TagOption } from 'components/shared/Tags/model';
import type { Underlying } from 'models/underlying';
import { createContext, ReactNode } from 'react';
import type { GroupBase } from 'react-select';
import styled from 'styled-components';
export const StyledNameTD = styled.td`
  min-width: 18rem;
`;
export function getTableLength(
  options: ReadonlyArray<TagOption<Underlying> | GroupBase<TagOption<Underlying>>>,
): number {
  return options.length;
}

export interface UnderlyingResultTableProps {
  children: ReactNode;
  options: ReadonlyArray<TagOption<Underlying> | GroupBase<TagOption<Underlying>>>;
}

export const InputTextContext = createContext<string>('');
